module.exports = __webpack_public_path__ + "img/hamza3.5b9b3204.png";